import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase rounded-full bg-secondary-100 text-secondary-700 mb-4">
            Frequently Asked
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            Everything About the ACBuy Spreadsheet
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base leading-relaxed">
            Clear answers to the most common questions from ACBuy spreadsheet users worldwide.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0 transition-transform duration-300">
                  <i
                    className={`ri-arrow-down-s-line text-foreground-600 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}